import api from "../../Hooks/axiosApi";

export const yourAddUpdateService = (formData: any) => {
    const response = api.post(`/api/MppClient/YourWhyPostOrUpdate`, formData);
    return response;
};

export const yourGetService = (clientId: any) => {
    const response = api.get(`/api/MppClient/GetYourWhy/${clientId}`);
    return response;
};

export const addUpdateHomeLoanResultsService = (data: any) => {
    const response = api.post(`/api/MppClient/InsertOrUpdateClientloanresult`, data);
    return response;
};

export const getHomeLoanResultsService = (clientId: any) => {
    const response = api.get(`/api/MppClient/Clientloanresult/${clientId}`);
    return response;
};